import { bindRequestLogic } from './utils'
import SubscriptionElectronicKeyTypes from '../actionTypes/subscriptionElectronicKey'
import { subscriptionElectronicKeyAPI } from '../api'

const getSubscriptionElectronicKeys = bindRequestLogic({
  clientFunc: subscriptionElectronicKeyAPI.getSubscriptionElectronicKeys,
  type: SubscriptionElectronicKeyTypes.GET_SUBSCRIPTION_ELECTRONIC_KEYS_REQUEST,
  successType:
    SubscriptionElectronicKeyTypes.GET_SUBSCRIPTION_ELECTRONIC_KEYS_SUCCESS,
  failType:
    SubscriptionElectronicKeyTypes.GET_SUBSCRIPTION_ELECTRONIC_KEYS_FAILED,
  isQueryParam: true,
  modelName: 'subscriptionVehicles'
})

const addSubscriptionElectronicKey = bindRequestLogic({
  clientFunc: subscriptionElectronicKeyAPI.addSubscriptionElectronicKey,
  type: SubscriptionElectronicKeyTypes.ADD_SUBSCRIPTION_ELECTRONIC_KEY_REQUEST,
  successType:
    SubscriptionElectronicKeyTypes.ADD_SUBSCRIPTION_ELECTRONIC_KEY_SUCCESS,
  failType:
    SubscriptionElectronicKeyTypes.ADD_SUBSCRIPTION_ELECTRONIC_KEY_FAILED
})

const updateSubscriptionElectronicKey = bindRequestLogic({
  clientFunc: subscriptionElectronicKeyAPI.updateSubscriptionElectronicKey,
  type: SubscriptionElectronicKeyTypes.UPDATE_SUBSCRIPTION_ELECTRONIC_KEY_REQUEST,
  successType:
    SubscriptionElectronicKeyTypes.UPDATE_SUBSCRIPTION_ELECTRONIC_KEY_SUCCESS,
  failType:
    SubscriptionElectronicKeyTypes.UPDATE_SUBSCRIPTION_ELECTRONIC_KEY_FAILED
})

const getSubscriptionElectronicKeyDetail = bindRequestLogic({
  clientFunc: subscriptionElectronicKeyAPI.getSubscriptionElectronicKeyDetail,
  type: SubscriptionElectronicKeyTypes.GET_SUBSCRIPTION_ELECTRONIC_KEY_DETAIL_REQUEST,
  successType:
    SubscriptionElectronicKeyTypes.GET_SUBSCRIPTION_ELECTRONIC_KEY_DETAIL_SUCCESS,
  failType:
    SubscriptionElectronicKeyTypes.GET_SUBSCRIPTION_ELECTRONIC_KEY_DETAIL_FAILED
})

const deleteSubscriptionElectronicKey = bindRequestLogic({
  clientFunc: subscriptionElectronicKeyAPI.deleteSubscriptionElectronicKey,
  type: SubscriptionElectronicKeyTypes.DELETE_SUBSCRIPTION_ELECTRONIC_KEY_REQUEST,
  successType:
    SubscriptionElectronicKeyTypes.DELETE_SUBSCRIPTION_ELECTRONIC_KEY_SUCCESS,
  failType:
    SubscriptionElectronicKeyTypes.DELETE_SUBSCRIPTION_ELECTRONIC_KEY_FAILED
})

export default [
  getSubscriptionElectronicKeys,
  addSubscriptionElectronicKey,
  getSubscriptionElectronicKeyDetail,
  deleteSubscriptionElectronicKey,
  updateSubscriptionElectronicKey
]
